const PricingBadge = ({ text }) => {
  return (
    <div className="absolute top-0 right-0 h-[22px] px-6 rounded-bl-2xl bg-brand-green flex items-center justify-center z-20">
      <span className="text-[12px] font-bold text-white tracking-wide">
        {text}
      </span>
    </div>
  )
}

export default PricingBadge